var LocalStorage = (function () {
    function LocalStorage() {
    }
    LocalStorage.getItem = function (key) {
        try {
            var data = window.localStorage.getItem(key);
            if (data === null) {
                return;
            }
            return data;
        }
        catch (e) {
            return;
        }
    };
    LocalStorage.setItem = function (key, value) {
        try {
            window.localStorage.setItem(key, value);
        }
        catch (e) {
            return;
        }
    };
    LocalStorage.removeItem = function (key) {
        try {
            window.localStorage.removeItem(key);
        }
        catch (e) {
            return;
        }
    };
    return LocalStorage;
}());
export { LocalStorage };
(function (LocalStorage) {
    var Key;
    (function (Key) {
        Key["PID"] = "pid";
        Key["AUTHENTICATOR"] = "authenticator";
        Key["SUB_AUTHENTICATOR"] = "subAuthenticator";
        Key["KEEP_POPUP_OPEN"] = "keepPopupOpen";
    })(Key = LocalStorage.Key || (LocalStorage.Key = {}));
})(LocalStorage || (LocalStorage = {}));
